import { Component } from '@angular/core';

@Component({
  selector: 'app-web-integration',
  templateUrl: './web-integration.component.html',
})
export class WebIntegrationComponent {

  constructor() {


    //window.location.href = "https://docsend.com/view/ridrp69k78r9cwdj";


  }

}
